export const SET_TRA_GOP_EDIT = 'SET_TRA_GOP_EDIT_TMTG';
export const SET_CONFIG_TM_TRA_GOP = 'SET_CONFIG_TM_TRA_GOP';
export const SHOW_FORM_TRA_GOP = 'SHOW_FORM_TRA_GOP';
export const GET_CONFIG_SYS_TMTG = 'GET_CONFIG_SYS_TMTG';
export const POST_TRA_GOP = 'POST_TRA_GOP';
export const POST_TRA_GOP_SUCCESS = 'POST_TRA_GOP_SUCCESS';
export const POST_TRA_GOP_FAILURE = 'POST_TRA_GOP_FAILURE';
export const CHECK_EDIT_TRA_GOP = 'CHECK_EDIT_TRA_GOP';
export const CHECK_EDIT_CUSTOMER_TG = 'CHECK_EDIT_CUSTOMER_TG';
export const SET_ENABLE_EDIT_TRA_GOP = 'SET_ENABLE_EDIT_TRA_GOP';
export const SET_ENABLE_EDIT_CUSTOMER_TG = 'SET_ENABLE_EDIT_CUSTOMER_TG';
export const SET_TAI_SAN_TG = 'SET_TAI_SAN_TG';
export const GET_TAI_SAN_THEO_CHO_VAY_TMTG = 'GET_TAI_SAN_THEO_CHO_VAY_TMTG';
